export enum FilterType {
  DATEONLY = "DATEONLY",
  DATEANDTRANSACTION = "DATEANDTRANSACTION",
}
export enum ModalType {
  PAYOUT_PLAN = "PAYOUT_PLAN",
  REFUND_ITEMS = "REFUND_ITEMS",
  DELIVERY_INCENTIVE = "DELIVERY_INCENTIVE",
  ATTENDANCE_INCENTIVE = "ATTENDANCE_INCENTIVE",
}

export enum WalletTxnType {
  ALL = "ALL",
  EARNING = "EARNING",
  REFUND = "REFUND",
  WITHDRAWAL = "WITHDRAWAL",
  TDS = "TDS",
  DELIVERY_FEE = "DELIVERY_FEE",
  INCENTIVE_FEE = "INCENTIVE_FEE",
  PENALTY = "PENALTY",
  FAKE_RTO = "FAKE_RTO",
  CRATE_PENALTY = "CRATE_PENALTY",
  RVP_PICKUP_MISSING = "RVP_PICKUP_MISSING",
  HIGH_RTO = "HIGH_RTO",
  HIGH_DAMAGE = "HIGH_DAMAGE",
}
